export default __webpack_public_path__ + "static/media/number_of_household_mapped.627ca989.svg";